import { styled } from "@mui/material/styles";
import { Slider } from "@mui/material";
import { APP_COLOR } from "../../theme";

export const PrettoSlider = styled(Slider)({
    color: APP_COLOR,
    height: 8,
    "& .MuiSlider-track": {
        border: "none",
        height: 8,
    },
    "& .MuiSlider-thumb": {
        height: 15,
        width: 15,
        backgroundColor: "#fff",
        border: "2px solid currentColor",
        transition: "transform 0.2s ease",
        "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
            boxShadow: "inherit",
        },
        "&::before": {
            display: "none",
        },
    },
    "& .MuiSlider-valueLabel": {
        fontSize: 16,
        background: "unset",
        color: APP_COLOR,
        width: 24,
        height: 24,
        borderRadius: "50%",
        top: "20px",
        transform: "translateX(0%)",
        display: "none",
    },
});

interface ValueLabelProps {
    left: string;
}

export const ValueLabel = styled("div")<ValueLabelProps>(({ left }) => ({
    position: "absolute",
    left: left,
    bottom: -10,
    transform: "translateX(-50%)",
    fontSize: 16,
    fontWeight: "bold",
    color: APP_COLOR,
    marginTop: "8px",
}));
